import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      id: 0,
      code: '',
      disabled: false,
      principal: 0,
      balance: 0,
      purchaserName: '',
      purchaserEmail: '',
      recipientName: '',
      recipientEmail: '',
      datePurchased: new Date(),
      expiration: new Date(),
      message: '',
      giftCodePrefix: '',
      amount:'',
      quantity:'',
      giftCodeLength:'',
      active: false
    },
  ],
  giftcard: {
    id: 0,
    code: '',
    disabled: false,
    principal: 0,
    balance: 0,
    purchaserName: '',
    purchaserEmail: '',
    recipientName: '',
    recipientEmail: '',
    datePurchased: new Date(),
    expiration: new Date(),
    message: '',
    giftCodePrefix: '',
    amount:'',
    quantity:'',
    giftCodeLength:'',
    active: false
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/giftcards?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function giftcards(state = initialState, action) {
  switch (action.type) {
    case types.GIFTCARDS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.GIFTCARDS_FETCH_ERROR:
    case types.GIFTCARD_FETCH_ERROR:
    case types.GIFTCARD_EDIT_ERROR:
    case types.GIFTCARD_SET_ERROR:
    case types.GIFTCARD_NEW_ERROR:
    case types.GIFTCARD_DISABLE_ERROR:
      console.log('ERROR***', action.res);
      return assign({}, state, {
        error: action.res,
      });
    case types.GIFTCARD_FETCH_SUCCESS:
    case types.GIFTCARD_EDIT_SUCCESS:
    case types.GIFTCARD_SET_SUCCESS:
    case types.GIFTCARD_NEW_SUCCESS:
      return assign({}, state, {
        giftcard: action.res,
      });
    case types.GIFTCARD_DISABLE_SUCCESS:
      return assign({}, state, {
        giftcardDisabled: action.res.ok,
      });
    case types.GIFTCARD_DELETE_SUCCESS:
      return assign({}, state, {
        giftcardDelete: action.res.ok,
      });
    case types.GIFTCARD_UPDATE_SUCCESS:
      return assign({}, state, {
        giftcard: action.res,
      });
    case types.GIFTCARD_UPDATE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.GIFTCARDS_CLEAR_ERRORS:
    case types.GIFTCARD_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default giftcards;



// WEBPACK FOOTER //
// ./src/reducers/giftCards.js